/**
 * GENERATED by apps/web/scripts/audio/build.mjs (sources: apps/web/public/assets/audio/CREDITS.md). Do not edit by hand.
 * Sprites and loops live in /assets/audio as .webm (Opus) with an .mp3 fallback.
 * clips: "<sound id>#<variant>" -> sprite + offset/length in seconds + source packs (spec.mjs PACKS).
 */
export interface SpriteEntry { file: string; dur: number }
export interface ClipEntry { sprite: string; start: number; dur: number; src: string[] }
export interface LoopEntry { file: string; start: number; dur: number; src: string[] }
export const AUDIO_MANIFEST: { build: { chain: string; packs: string[] }; sprites: Record<string, SpriteEntry>; clips: Record<string, ClipEntry>; loops: Record<string, LoopEntry> } = {
  "build": {
    "chain": "keystone-audio-v2",
    "packs": [
      "tm",
      "rd"
    ]
  },
  "sprites": {
    "combat": {
      "file": "sfx-combat",
      "dur": 131.208
    },
    "ui": {
      "file": "sfx-ui",
      "dur": 8.017
    },
    "meta": {
      "file": "sfx-meta",
      "dur": 28.786
    }
  },
  "clips": {
    "swing#0": {
      "sprite": "combat",
      "start": 0.12,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "swing#1": {
      "sprite": "combat",
      "start": 0.59,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "swing#2": {
      "sprite": "combat",
      "start": 1.06,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "swing#3": {
      "sprite": "combat",
      "start": 1.53,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "swing#4": {
      "sprite": "combat",
      "start": 2,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "swing.light#0": {
      "sprite": "combat",
      "start": 2.47,
      "dur": 0.28,
      "src": [
        "tm"
      ]
    },
    "swing.light#1": {
      "sprite": "combat",
      "start": 2.87,
      "dur": 0.28,
      "src": [
        "tm"
      ]
    },
    "swing.light#2": {
      "sprite": "combat",
      "start": 3.27,
      "dur": 0.28,
      "src": [
        "tm"
      ]
    },
    "swing.heavy#0": {
      "sprite": "combat",
      "start": 3.67,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "swing.heavy#1": {
      "sprite": "combat",
      "start": 4.39,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "swing.heavy#2": {
      "sprite": "combat",
      "start": 5.11,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "hit.blade#0": {
      "sprite": "combat",
      "start": 5.83,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "hit.blade#1": {
      "sprite": "combat",
      "start": 6.35,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "hit.blade#2": {
      "sprite": "combat",
      "start": 6.87,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "hit.blade#3": {
      "sprite": "combat",
      "start": 7.39,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "hit.blade#4": {
      "sprite": "combat",
      "start": 7.91,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "hit.blade.heavy#0": {
      "sprite": "combat",
      "start": 8.43,
      "dur": 0.498,
      "src": [
        "tm"
      ]
    },
    "hit.blade.heavy#1": {
      "sprite": "combat",
      "start": 9.048,
      "dur": 0.5883,
      "src": [
        "tm"
      ]
    },
    "hit.blade.heavy#2": {
      "sprite": "combat",
      "start": 9.7563,
      "dur": 0.5198,
      "src": [
        "tm"
      ]
    },
    "hit.blunt#0": {
      "sprite": "combat",
      "start": 10.3961,
      "dur": 0.3714,
      "src": [
        "tm"
      ]
    },
    "hit.blunt#1": {
      "sprite": "combat",
      "start": 10.8874,
      "dur": 0.4721,
      "src": [
        "tm"
      ]
    },
    "hit.blunt#2": {
      "sprite": "combat",
      "start": 11.4795,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.shield#0": {
      "sprite": "combat",
      "start": 12.0995,
      "dur": 0.48,
      "src": [
        "tm"
      ]
    },
    "hit.shield#1": {
      "sprite": "combat",
      "start": 12.6995,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.shield#2": {
      "sprite": "combat",
      "start": 13.3195,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.execute#0": {
      "sprite": "combat",
      "start": 13.9395,
      "dur": 0.5883,
      "src": [
        "tm"
      ]
    },
    "hit.execute#1": {
      "sprite": "combat",
      "start": 14.6478,
      "dur": 0.5883,
      "src": [
        "tm"
      ]
    },
    "hit.earth#0": {
      "sprite": "combat",
      "start": 15.356,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.earth#1": {
      "sprite": "combat",
      "start": 15.976,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.earth#2": {
      "sprite": "combat",
      "start": 16.596,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "hit.arrow#0": {
      "sprite": "combat",
      "start": 17.416,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.arrow#1": {
      "sprite": "combat",
      "start": 18.036,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.arrow#2": {
      "sprite": "combat",
      "start": 18.656,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.arrow#3": {
      "sprite": "combat",
      "start": 19.276,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "bow.shot#0": {
      "sprite": "combat",
      "start": 19.896,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "bow.shot#1": {
      "sprite": "combat",
      "start": 20.466,
      "dur": 0.385,
      "src": [
        "tm"
      ]
    },
    "bow.shot#2": {
      "sprite": "combat",
      "start": 20.9711,
      "dur": 0.4245,
      "src": [
        "tm"
      ]
    },
    "interrupt#0": {
      "sprite": "combat",
      "start": 21.5156,
      "dur": 0.44,
      "src": [
        "tm"
      ]
    },
    "interrupt#1": {
      "sprite": "combat",
      "start": 22.0756,
      "dur": 0.48,
      "src": [
        "tm"
      ]
    },
    "dodge#0": {
      "sprite": "combat",
      "start": 22.6756,
      "dur": 0.3916,
      "src": [
        "tm"
      ]
    },
    "dodge#1": {
      "sprite": "combat",
      "start": 23.1872,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "dodge#2": {
      "sprite": "combat",
      "start": 23.7572,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "hurt#0": {
      "sprite": "combat",
      "start": 24.3272,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hurt#1": {
      "sprite": "combat",
      "start": 24.9473,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hurt#2": {
      "sprite": "combat",
      "start": 25.5673,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "enemy.hit#0": {
      "sprite": "combat",
      "start": 26.1872,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "enemy.hit#1": {
      "sprite": "combat",
      "start": 26.6573,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "enemy.hit#2": {
      "sprite": "combat",
      "start": 27.1273,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "enemy.hit#3": {
      "sprite": "combat",
      "start": 27.5972,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "slam#0": {
      "sprite": "combat",
      "start": 28.0673,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "slam#1": {
      "sprite": "combat",
      "start": 29.3873,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "crit#0": {
      "sprite": "combat",
      "start": 30.7072,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "crit#1": {
      "sprite": "combat",
      "start": 31.2273,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "kill#0": {
      "sprite": "combat",
      "start": 31.7473,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "kill#1": {
      "sprite": "combat",
      "start": 32.3173,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "trap.spring#0": {
      "sprite": "combat",
      "start": 32.8873,
      "dur": 0.2346,
      "src": [
        "tm"
      ]
    },
    "hit.fire#0": {
      "sprite": "combat",
      "start": 33.2418,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "hit.fire#1": {
      "sprite": "combat",
      "start": 34.2618,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "hit.fire#2": {
      "sprite": "combat",
      "start": 35.2818,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "hit.fire.small#0": {
      "sprite": "combat",
      "start": 36.3018,
      "dur": 0.4051,
      "src": [
        "tm"
      ]
    },
    "hit.fire.small#1": {
      "sprite": "combat",
      "start": 36.8269,
      "dur": 0.45,
      "src": [
        "tm"
      ]
    },
    "hit.fire.small#2": {
      "sprite": "combat",
      "start": 37.3969,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "cast.fire#0": {
      "sprite": "combat",
      "start": 38.0169,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "cast.fire#1": {
      "sprite": "combat",
      "start": 38.8369,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "cast.charge.fire#0": {
      "sprite": "combat",
      "start": 39.6569,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "hit.frost#0": {
      "sprite": "combat",
      "start": 40.7769,
      "dur": 0.6112,
      "src": [
        "tm"
      ]
    },
    "hit.frost#1": {
      "sprite": "combat",
      "start": 41.5081,
      "dur": 0.5836,
      "src": [
        "tm"
      ]
    },
    "hit.frost#2": {
      "sprite": "combat",
      "start": 42.2118,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "hit.frost#3": {
      "sprite": "combat",
      "start": 43.0318,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "hit.lightning#0": {
      "sprite": "combat",
      "start": 43.8518,
      "dur": 0.4146,
      "src": [
        "tm"
      ]
    },
    "hit.lightning#1": {
      "sprite": "combat",
      "start": 44.3863,
      "dur": 0.4167,
      "src": [
        "tm"
      ]
    },
    "hit.lightning#2": {
      "sprite": "combat",
      "start": 44.923,
      "dur": 0.3646,
      "src": [
        "tm"
      ]
    },
    "hit.lightning.big#0": {
      "sprite": "combat",
      "start": 45.4076,
      "dur": 1.6,
      "src": [
        "tm"
      ]
    },
    "hit.lightning.big#1": {
      "sprite": "combat",
      "start": 47.1276,
      "dur": 1.6,
      "src": [
        "tm"
      ]
    },
    "chain#0": {
      "sprite": "combat",
      "start": 48.8476,
      "dur": 0.3,
      "src": [
        "tm"
      ]
    },
    "chain#1": {
      "sprite": "combat",
      "start": 49.2676,
      "dur": 0.3,
      "src": [
        "tm"
      ]
    },
    "chain#2": {
      "sprite": "combat",
      "start": 49.6876,
      "dur": 0.3,
      "src": [
        "tm"
      ]
    },
    "cast.charge.storm#0": {
      "sprite": "combat",
      "start": 50.1076,
      "dur": 0.8,
      "src": [
        "tm"
      ]
    },
    "hit.holy#0": {
      "sprite": "combat",
      "start": 51.0276,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "hit.holy#1": {
      "sprite": "combat",
      "start": 52.0476,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "hit.holy.big#0": {
      "sprite": "combat",
      "start": 53.0676,
      "dur": 1.3,
      "src": [
        "tm"
      ]
    },
    "hit.holy.big#1": {
      "sprite": "combat",
      "start": 54.4876,
      "dur": 1.0787,
      "src": [
        "tm"
      ]
    },
    "cast.holy#0": {
      "sprite": "combat",
      "start": 55.6863,
      "dur": 0.8406,
      "src": [
        "tm"
      ]
    },
    "cast.holy#1": {
      "sprite": "combat",
      "start": 56.6469,
      "dur": 0.7669,
      "src": [
        "tm"
      ]
    },
    "hit.shadow#0": {
      "sprite": "combat",
      "start": 57.5338,
      "dur": 0.8333,
      "src": [
        "tm"
      ]
    },
    "hit.shadow#1": {
      "sprite": "combat",
      "start": 58.4871,
      "dur": 0.7692,
      "src": [
        "tm"
      ]
    },
    "hit.arcane#0": {
      "sprite": "combat",
      "start": 59.3764,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "hit.arcane#1": {
      "sprite": "combat",
      "start": 60.0964,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "hit.arcane#2": {
      "sprite": "combat",
      "start": 60.8164,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "hit.venom#0": {
      "sprite": "combat",
      "start": 61.5364,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "hit.venom#1": {
      "sprite": "combat",
      "start": 62.1564,
      "dur": 0.4861,
      "src": [
        "tm"
      ]
    },
    "hit.venom#2": {
      "sprite": "combat",
      "start": 62.7625,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "heal#0": {
      "sprite": "combat",
      "start": 63.3825,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "heal#1": {
      "sprite": "combat",
      "start": 64.4025,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "heal#2": {
      "sprite": "combat",
      "start": 65.4225,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "heal.big#0": {
      "sprite": "combat",
      "start": 66.4425,
      "dur": 1.3885,
      "src": [
        "tm"
      ]
    },
    "heal.big#1": {
      "sprite": "combat",
      "start": 67.951,
      "dur": 1.2967,
      "src": [
        "tm"
      ]
    },
    "nova#0": {
      "sprite": "combat",
      "start": 69.3677,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "nova#1": {
      "sprite": "combat",
      "start": 70.6877,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "shield.up#0": {
      "sprite": "combat",
      "start": 72.0077,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "shield.up#1": {
      "sprite": "combat",
      "start": 73.1277,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "shield.absorb#0": {
      "sprite": "combat",
      "start": 74.2477,
      "dur": 0.2609,
      "src": [
        "tm"
      ]
    },
    "shield.absorb#1": {
      "sprite": "combat",
      "start": 74.6286,
      "dur": 0.2727,
      "src": [
        "tm"
      ]
    },
    "dispel#0": {
      "sprite": "combat",
      "start": 75.0213,
      "dur": 0.5959,
      "src": [
        "tm"
      ]
    },
    "proc#0": {
      "sprite": "combat",
      "start": 75.7372,
      "dur": 0.6814,
      "src": [
        "tm"
      ]
    },
    "cast.charge#0": {
      "sprite": "combat",
      "start": 76.5386,
      "dur": 0.7826,
      "src": [
        "tm"
      ]
    },
    "cast.charge#1": {
      "sprite": "combat",
      "start": 77.4412,
      "dur": 0.75,
      "src": [
        "tm"
      ]
    },
    "cast.fail#0": {
      "sprite": "combat",
      "start": 78.3112,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "cast.fail#1": {
      "sprite": "combat",
      "start": 78.7812,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "telegraph#0": {
      "sprite": "combat",
      "start": 79.2512,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "enemy.cast#0": {
      "sprite": "combat",
      "start": 80.5712,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "enemy.cast#1": {
      "sprite": "combat",
      "start": 81.6912,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "mob.aggro#0": {
      "sprite": "combat",
      "start": 82.8112,
      "dur": 0.475,
      "src": [
        "rd"
      ]
    },
    "mob.aggro#1": {
      "sprite": "combat",
      "start": 83.4062,
      "dur": 0.5075,
      "src": [
        "rd"
      ]
    },
    "mob.aggro#2": {
      "sprite": "combat",
      "start": 84.0337,
      "dur": 0.4383,
      "src": [
        "rd"
      ]
    },
    "mob.aggro#3": {
      "sprite": "combat",
      "start": 84.592,
      "dur": 0.276,
      "src": [
        "rd"
      ]
    },
    "mob.death#0": {
      "sprite": "combat",
      "start": 84.988,
      "dur": 0.3665,
      "src": [
        "rd"
      ]
    },
    "mob.death#1": {
      "sprite": "combat",
      "start": 85.4745,
      "dur": 0.5459,
      "src": [
        "rd"
      ]
    },
    "mob.death#2": {
      "sprite": "combat",
      "start": 86.1404,
      "dur": 0.5469,
      "src": [
        "rd"
      ]
    },
    "mob.death#3": {
      "sprite": "combat",
      "start": 86.8073,
      "dur": 0.7407,
      "src": [
        "rd"
      ]
    },
    "boss.roar#0": {
      "sprite": "combat",
      "start": 87.668,
      "dur": 0.824,
      "src": [
        "rd"
      ]
    },
    "boss.roar#1": {
      "sprite": "combat",
      "start": 88.612,
      "dur": 0.9247,
      "src": [
        "rd"
      ]
    },
    "death.self#0": {
      "sprite": "combat",
      "start": 89.6566,
      "dur": 2,
      "src": [
        "tm"
      ]
    },
    "death.party#0": {
      "sprite": "combat",
      "start": 91.7766,
      "dur": 1.5,
      "src": [
        "tm"
      ]
    },
    "heartbeat#0": {
      "sprite": "combat",
      "start": 93.3966,
      "dur": 0.4864,
      "src": [
        "tm"
      ]
    },
    "object.hit#0": {
      "sprite": "combat",
      "start": 94.0031,
      "dur": 0.333,
      "src": [
        "tm"
      ]
    },
    "object.hit#1": {
      "sprite": "combat",
      "start": 94.456,
      "dur": 0.3357,
      "src": [
        "tm"
      ]
    },
    "object.hit#2": {
      "sprite": "combat",
      "start": 94.9117,
      "dur": 0.266,
      "src": [
        "tm"
      ]
    },
    "object.break#0": {
      "sprite": "combat",
      "start": 95.2977,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "object.break#1": {
      "sprite": "combat",
      "start": 96.1177,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "chest.open#0": {
      "sprite": "combat",
      "start": 96.9377,
      "dur": 1.1549,
      "src": [
        "tm"
      ]
    },
    "chest.open#1": {
      "sprite": "combat",
      "start": 98.2126,
      "dur": 1.3,
      "src": [
        "tm"
      ]
    },
    "chest.close#0": {
      "sprite": "combat",
      "start": 99.6326,
      "dur": 0.7406,
      "src": [
        "tm"
      ]
    },
    "chest.close#1": {
      "sprite": "combat",
      "start": 100.4932,
      "dur": 0.7606,
      "src": [
        "tm"
      ]
    },
    "pickup#0": {
      "sprite": "combat",
      "start": 101.3738,
      "dur": 0.1315,
      "src": [
        "tm"
      ]
    },
    "pickup#1": {
      "sprite": "combat",
      "start": 101.6253,
      "dur": 0.1012,
      "src": [
        "tm"
      ]
    },
    "pickup#2": {
      "sprite": "combat",
      "start": 101.8465,
      "dur": 0.1201,
      "src": [
        "tm"
      ]
    },
    "door.open#0": {
      "sprite": "combat",
      "start": 102.0866,
      "dur": 1.1609,
      "src": [
        "tm"
      ]
    },
    "door.open#1": {
      "sprite": "combat",
      "start": 103.3675,
      "dur": 0.9971,
      "src": [
        "tm"
      ]
    },
    "door.close#0": {
      "sprite": "combat",
      "start": 104.4846,
      "dur": 0.619,
      "src": [
        "tm"
      ]
    },
    "door.close#1": {
      "sprite": "combat",
      "start": 105.2236,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "gate.open#0": {
      "sprite": "combat",
      "start": 106.2436,
      "dur": 1.073,
      "src": [
        "tm"
      ]
    },
    "gate.close#0": {
      "sprite": "combat",
      "start": 107.4366,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "lock.unlock#0": {
      "sprite": "combat",
      "start": 108.4566,
      "dur": 0.9484,
      "src": [
        "tm"
      ]
    },
    "gather.chop#0": {
      "sprite": "combat",
      "start": 109.525,
      "dur": 0.333,
      "src": [
        "tm"
      ]
    },
    "gather.chop#1": {
      "sprite": "combat",
      "start": 109.978,
      "dur": 0.1873,
      "src": [
        "tm"
      ]
    },
    "gather.chop#2": {
      "sprite": "combat",
      "start": 110.2853,
      "dur": 0.3357,
      "src": [
        "tm"
      ]
    },
    "gather.chop#3": {
      "sprite": "combat",
      "start": 110.741,
      "dur": 0.266,
      "src": [
        "tm"
      ]
    },
    "gather.mine#0": {
      "sprite": "combat",
      "start": 111.127,
      "dur": 0.339,
      "src": [
        "tm"
      ]
    },
    "gather.mine#1": {
      "sprite": "combat",
      "start": 111.586,
      "dur": 0.2926,
      "src": [
        "tm"
      ]
    },
    "gather.mine#2": {
      "sprite": "combat",
      "start": 111.9986,
      "dur": 0.2864,
      "src": [
        "tm"
      ]
    },
    "gather.mine#3": {
      "sprite": "combat",
      "start": 112.405,
      "dur": 0.2861,
      "src": [
        "tm"
      ]
    },
    "gather.mine#4": {
      "sprite": "combat",
      "start": 112.8111,
      "dur": 0.3535,
      "src": [
        "tm"
      ]
    },
    "gather.herb#0": {
      "sprite": "combat",
      "start": 113.2846,
      "dur": 0.176,
      "src": [
        "tm"
      ]
    },
    "gather.herb#1": {
      "sprite": "combat",
      "start": 113.5806,
      "dur": 0.176,
      "src": [
        "tm"
      ]
    },
    "gather.herb#2": {
      "sprite": "combat",
      "start": 113.8766,
      "dur": 0.1758,
      "src": [
        "tm"
      ]
    },
    "torch.light#0": {
      "sprite": "combat",
      "start": 114.1724,
      "dur": 1.2,
      "src": [
        "tm"
      ]
    },
    "torch.light#1": {
      "sprite": "combat",
      "start": 115.4924,
      "dur": 0.5909,
      "src": [
        "tm"
      ]
    },
    "step.stone#0": {
      "sprite": "combat",
      "start": 116.2032,
      "dur": 0.0635,
      "src": [
        "tm"
      ]
    },
    "step.stone#1": {
      "sprite": "combat",
      "start": 116.3868,
      "dur": 0.0737,
      "src": [
        "tm"
      ]
    },
    "step.stone#2": {
      "sprite": "combat",
      "start": 116.5805,
      "dur": 0.0616,
      "src": [
        "tm"
      ]
    },
    "step.stone#3": {
      "sprite": "combat",
      "start": 116.7621,
      "dur": 0.0937,
      "src": [
        "tm"
      ]
    },
    "step.stone#4": {
      "sprite": "combat",
      "start": 116.9758,
      "dur": 0.0706,
      "src": [
        "tm"
      ]
    },
    "step.stone#5": {
      "sprite": "combat",
      "start": 117.1664,
      "dur": 0.09,
      "src": [
        "tm"
      ]
    },
    "step.stone#6": {
      "sprite": "combat",
      "start": 117.3764,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.stone#7": {
      "sprite": "combat",
      "start": 117.5814,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.stone#8": {
      "sprite": "combat",
      "start": 117.7865,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.stone#9": {
      "sprite": "combat",
      "start": 117.9915,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.dirt#0": {
      "sprite": "combat",
      "start": 118.1965,
      "dur": 0.0867,
      "src": [
        "tm"
      ]
    },
    "step.dirt#1": {
      "sprite": "combat",
      "start": 118.4032,
      "dur": 0.0869,
      "src": [
        "tm"
      ]
    },
    "step.dirt#2": {
      "sprite": "combat",
      "start": 118.6102,
      "dur": 0.075,
      "src": [
        "tm"
      ]
    },
    "step.dirt#3": {
      "sprite": "combat",
      "start": 118.8052,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.dirt#4": {
      "sprite": "combat",
      "start": 119.0252,
      "dur": 0.0881,
      "src": [
        "tm"
      ]
    },
    "step.dirt#5": {
      "sprite": "combat",
      "start": 119.2333,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.dirt#6": {
      "sprite": "combat",
      "start": 119.4383,
      "dur": 0.048,
      "src": [
        "tm"
      ]
    },
    "step.dirt#7": {
      "sprite": "combat",
      "start": 119.6063,
      "dur": 0.0886,
      "src": [
        "tm"
      ]
    },
    "step.wood#0": {
      "sprite": "combat",
      "start": 119.815,
      "dur": 0.0504,
      "src": [
        "tm"
      ]
    },
    "step.wood#1": {
      "sprite": "combat",
      "start": 119.9853,
      "dur": 0.104,
      "src": [
        "tm"
      ]
    },
    "step.wood#2": {
      "sprite": "combat",
      "start": 120.2093,
      "dur": 0.1135,
      "src": [
        "tm"
      ]
    },
    "step.wood#3": {
      "sprite": "combat",
      "start": 120.4428,
      "dur": 0.1167,
      "src": [
        "tm"
      ]
    },
    "step.wood#4": {
      "sprite": "combat",
      "start": 120.6795,
      "dur": 0.105,
      "src": [
        "tm"
      ]
    },
    "step.wood#5": {
      "sprite": "combat",
      "start": 120.9045,
      "dur": 0.0859,
      "src": [
        "tm"
      ]
    },
    "step.wood#6": {
      "sprite": "combat",
      "start": 121.1104,
      "dur": 0.08,
      "src": [
        "tm"
      ]
    },
    "step.wood#7": {
      "sprite": "combat",
      "start": 121.3104,
      "dur": 0.0982,
      "src": [
        "tm"
      ]
    },
    "step.wet#0": {
      "sprite": "combat",
      "start": 121.5286,
      "dur": 0.0885,
      "src": [
        "tm"
      ]
    },
    "step.wet#1": {
      "sprite": "combat",
      "start": 121.7371,
      "dur": 0.09,
      "src": [
        "tm"
      ]
    },
    "step.wet#2": {
      "sprite": "combat",
      "start": 121.9471,
      "dur": 0.098,
      "src": [
        "tm"
      ]
    },
    "step.wet#3": {
      "sprite": "combat",
      "start": 122.1651,
      "dur": 0.0866,
      "src": [
        "tm"
      ]
    },
    "step.wet#4": {
      "sprite": "combat",
      "start": 122.3717,
      "dur": 0.09,
      "src": [
        "tm"
      ]
    },
    "step.wet#5": {
      "sprite": "combat",
      "start": 122.5817,
      "dur": 0.0893,
      "src": [
        "tm"
      ]
    },
    "step.wet#6": {
      "sprite": "combat",
      "start": 122.791,
      "dur": 0.0969,
      "src": [
        "tm"
      ]
    },
    "step.wet#7": {
      "sprite": "combat",
      "start": 123.0078,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.wet#8": {
      "sprite": "combat",
      "start": 123.2278,
      "dur": 0.0979,
      "src": [
        "tm"
      ]
    },
    "step.grass#0": {
      "sprite": "combat",
      "start": 123.4457,
      "dur": 0.0967,
      "src": [
        "tm"
      ]
    },
    "step.grass#1": {
      "sprite": "combat",
      "start": 123.6624,
      "dur": 0.086,
      "src": [
        "tm"
      ]
    },
    "step.grass#2": {
      "sprite": "combat",
      "start": 123.8684,
      "dur": 0.09,
      "src": [
        "tm"
      ]
    },
    "step.grass#3": {
      "sprite": "combat",
      "start": 124.0784,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.grass#4": {
      "sprite": "combat",
      "start": 124.2984,
      "dur": 0.0885,
      "src": [
        "tm"
      ]
    },
    "step.grass#5": {
      "sprite": "combat",
      "start": 124.5069,
      "dur": 0.0964,
      "src": [
        "tm"
      ]
    },
    "step.grass#6": {
      "sprite": "combat",
      "start": 124.7233,
      "dur": 0.1087,
      "src": [
        "tm"
      ]
    },
    "step.grass#7": {
      "sprite": "combat",
      "start": 124.952,
      "dur": 0.0962,
      "src": [
        "tm"
      ]
    },
    "step.gravel#0": {
      "sprite": "combat",
      "start": 125.1682,
      "dur": 0.0868,
      "src": [
        "tm"
      ]
    },
    "step.gravel#1": {
      "sprite": "combat",
      "start": 125.375,
      "dur": 0.0882,
      "src": [
        "tm"
      ]
    },
    "step.gravel#2": {
      "sprite": "combat",
      "start": 125.5832,
      "dur": 0.075,
      "src": [
        "tm"
      ]
    },
    "step.gravel#3": {
      "sprite": "combat",
      "start": 125.7782,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.gravel#4": {
      "sprite": "combat",
      "start": 125.9982,
      "dur": 0.0881,
      "src": [
        "tm"
      ]
    },
    "step.gravel#5": {
      "sprite": "combat",
      "start": 126.2063,
      "dur": 0.0882,
      "src": [
        "tm"
      ]
    },
    "step.gravel#6": {
      "sprite": "combat",
      "start": 126.4145,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.gravel#7": {
      "sprite": "combat",
      "start": 126.6345,
      "dur": 0.0868,
      "src": [
        "tm"
      ]
    },
    "step.carpet#0": {
      "sprite": "combat",
      "start": 126.8413,
      "dur": 0.0965,
      "src": [
        "tm"
      ]
    },
    "step.carpet#1": {
      "sprite": "combat",
      "start": 127.0578,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "step.carpet#2": {
      "sprite": "combat",
      "start": 127.2629,
      "dur": 0.075,
      "src": [
        "tm"
      ]
    },
    "step.carpet#3": {
      "sprite": "combat",
      "start": 127.4579,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "step.carpet#4": {
      "sprite": "combat",
      "start": 127.6779,
      "dur": 0.0876,
      "src": [
        "tm"
      ]
    },
    "step.carpet#5": {
      "sprite": "combat",
      "start": 127.8855,
      "dur": 0.085,
      "src": [
        "tm"
      ]
    },
    "move.jump#0": {
      "sprite": "combat",
      "start": 128.0905,
      "dur": 0.1,
      "src": [
        "tm"
      ]
    },
    "move.jump#1": {
      "sprite": "combat",
      "start": 128.3105,
      "dur": 0.13,
      "src": [
        "tm"
      ]
    },
    "move.jump#2": {
      "sprite": "combat",
      "start": 128.5605,
      "dur": 0.1017,
      "src": [
        "tm"
      ]
    },
    "move.land#0": {
      "sprite": "combat",
      "start": 128.7822,
      "dur": 0.14,
      "src": [
        "tm"
      ]
    },
    "move.land#1": {
      "sprite": "combat",
      "start": 129.0422,
      "dur": 0.14,
      "src": [
        "tm"
      ]
    },
    "move.land#2": {
      "sprite": "combat",
      "start": 129.3022,
      "dur": 0.12,
      "src": [
        "tm"
      ]
    },
    "move.land#3": {
      "sprite": "combat",
      "start": 129.5422,
      "dur": 0.1522,
      "src": [
        "tm"
      ]
    },
    "level.impact#0": {
      "sprite": "combat",
      "start": 129.8144,
      "dur": 1.2733,
      "src": [
        "tm"
      ]
    },
    "ui.click#0": {
      "sprite": "ui",
      "start": 0.12,
      "dur": 0.07,
      "src": [
        "tm"
      ]
    },
    "ui.click#1": {
      "sprite": "ui",
      "start": 0.31,
      "dur": 0.07,
      "src": [
        "tm"
      ]
    },
    "ui.click#2": {
      "sprite": "ui",
      "start": 0.5,
      "dur": 0.0648,
      "src": [
        "tm"
      ]
    },
    "ui.hover#0": {
      "sprite": "ui",
      "start": 0.6848,
      "dur": 0.04,
      "src": [
        "tm"
      ]
    },
    "ui.hover#1": {
      "sprite": "ui",
      "start": 0.8448,
      "dur": 0.04,
      "src": [
        "tm"
      ]
    },
    "ui.tick#0": {
      "sprite": "ui",
      "start": 1.0048,
      "dur": 0.05,
      "src": [
        "tm"
      ]
    },
    "ui.tick#1": {
      "sprite": "ui",
      "start": 1.1748,
      "dur": 0.05,
      "src": [
        "tm"
      ]
    },
    "ui.tab#0": {
      "sprite": "ui",
      "start": 1.3448,
      "dur": 0.12,
      "src": [
        "tm"
      ]
    },
    "ui.tab#1": {
      "sprite": "ui",
      "start": 1.5848,
      "dur": 0.12,
      "src": [
        "tm"
      ]
    },
    "ui.open#0": {
      "sprite": "ui",
      "start": 1.8248,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "ui.close#0": {
      "sprite": "ui",
      "start": 2.2948,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "ui.confirm#0": {
      "sprite": "ui",
      "start": 2.7648,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "ui.confirm#1": {
      "sprite": "ui",
      "start": 3.4848,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "ui.error#0": {
      "sprite": "ui",
      "start": 4.2048,
      "dur": 0.3,
      "src": [
        "tm"
      ]
    },
    "ui.chat#0": {
      "sprite": "ui",
      "start": 4.6248,
      "dur": 0.328,
      "src": [
        "tm"
      ]
    },
    "ui.chat#1": {
      "sprite": "ui",
      "start": 5.0729,
      "dur": 0.35,
      "src": [
        "tm"
      ]
    },
    "ui.chime#0": {
      "sprite": "ui",
      "start": 5.5429,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "reward.xp#0": {
      "sprite": "ui",
      "start": 6.6629,
      "dur": 0.2767,
      "src": [
        "tm"
      ]
    },
    "reward.xp#1": {
      "sprite": "ui",
      "start": 7.0595,
      "dur": 0.2331,
      "src": [
        "tm"
      ]
    },
    "reward.coin#0": {
      "sprite": "ui",
      "start": 7.4127,
      "dur": 0.0746,
      "src": [
        "tm"
      ]
    },
    "reward.coin#1": {
      "sprite": "ui",
      "start": 7.6072,
      "dur": 0.0978,
      "src": [
        "tm"
      ]
    },
    "reward.coin#2": {
      "sprite": "ui",
      "start": 7.8251,
      "dur": 0.0715,
      "src": [
        "tm"
      ]
    },
    "party.invite#0": {
      "sprite": "meta",
      "start": 0.12,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "party.join#0": {
      "sprite": "meta",
      "start": 0.84,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "party.leave#0": {
      "sprite": "meta",
      "start": 1.56,
      "dur": 0.6,
      "src": [
        "tm"
      ]
    },
    "party.ragequit#0": {
      "sprite": "meta",
      "start": 2.28,
      "dur": 0.8,
      "src": [
        "tm"
      ]
    },
    "party.ragequit#1": {
      "sprite": "meta",
      "start": 3.2,
      "dur": 0.619,
      "src": [
        "tm"
      ]
    },
    "guild.recruit#0": {
      "sprite": "meta",
      "start": 3.939,
      "dur": 0.9,
      "src": [
        "tm"
      ]
    },
    "idle.claim#0": {
      "sprite": "meta",
      "start": 4.959,
      "dur": 0.9755,
      "src": [
        "tm"
      ]
    },
    "idle.tick#0": {
      "sprite": "meta",
      "start": 6.0545,
      "dur": 0.0689,
      "src": [
        "tm"
      ]
    },
    "idle.tick#1": {
      "sprite": "meta",
      "start": 6.2434,
      "dur": 0.0621,
      "src": [
        "tm"
      ]
    },
    "idle.tick#2": {
      "sprite": "meta",
      "start": 6.4255,
      "dur": 0.0563,
      "src": [
        "tm"
      ]
    },
    "loot.gear#0": {
      "sprite": "meta",
      "start": 6.6017,
      "dur": 0.4,
      "src": [
        "tm"
      ]
    },
    "loot.gear#1": {
      "sprite": "meta",
      "start": 7.1217,
      "dur": 0.25,
      "src": [
        "tm"
      ]
    },
    "loot.gear#2": {
      "sprite": "meta",
      "start": 7.4917,
      "dur": 0.3,
      "src": [
        "tm"
      ]
    },
    "loot.gem#0": {
      "sprite": "meta",
      "start": 7.9117,
      "dur": 0.473,
      "src": [
        "tm"
      ]
    },
    "loot.gem#1": {
      "sprite": "meta",
      "start": 8.5047,
      "dur": 0.3977,
      "src": [
        "tm"
      ]
    },
    "loot.bell#0": {
      "sprite": "meta",
      "start": 9.0224,
      "dur": 1.4,
      "src": [
        "tm"
      ]
    },
    "forge.hammer#0": {
      "sprite": "meta",
      "start": 10.5424,
      "dur": 0.48,
      "src": [
        "tm"
      ]
    },
    "forge.hammer#1": {
      "sprite": "meta",
      "start": 11.1424,
      "dur": 0.5,
      "src": [
        "tm"
      ]
    },
    "forge.hammer#2": {
      "sprite": "meta",
      "start": 11.7624,
      "dur": 0.463,
      "src": [
        "tm"
      ]
    },
    "forge.fail#0": {
      "sprite": "meta",
      "start": 12.3454,
      "dur": 0.575,
      "src": [
        "tm"
      ]
    },
    "key.go#0": {
      "sprite": "meta",
      "start": 13.0404,
      "dur": 2,
      "src": [
        "tm"
      ]
    },
    "boss.defeat#0": {
      "sprite": "meta",
      "start": 15.1604,
      "dur": 2,
      "src": [
        "tm"
      ]
    },
    "key.timed#0": {
      "sprite": "meta",
      "start": 17.2804,
      "dur": 1.9069,
      "src": [
        "tm"
      ]
    },
    "key.depleted#0": {
      "sprite": "meta",
      "start": 19.3073,
      "dur": 2.1103,
      "src": [
        "tm"
      ]
    },
    "level.up#0": {
      "sprite": "meta",
      "start": 21.5376,
      "dur": 1.5722,
      "src": [
        "tm"
      ]
    },
    "bounty.complete#0": {
      "sprite": "meta",
      "start": 23.2299,
      "dur": 0.7757,
      "src": [
        "tm"
      ]
    },
    "reward.item#0": {
      "sprite": "meta",
      "start": 24.1256,
      "dur": 0.7,
      "src": [
        "tm"
      ]
    },
    "reward.rare#0": {
      "sprite": "meta",
      "start": 24.9456,
      "dur": 1,
      "src": [
        "tm"
      ]
    },
    "wipe#0": {
      "sprite": "meta",
      "start": 26.0656,
      "dur": 2.6,
      "src": [
        "tm"
      ]
    }
  },
  "loops": {
    "amb.day": {
      "file": "amb/day",
      "start": 0.25,
      "dur": 40,
      "src": [
        "tm"
      ]
    },
    "amb.day.rain": {
      "file": "amb/day.rain",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.day.storm": {
      "file": "amb/day.storm",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.night": {
      "file": "amb/night",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.dungeon": {
      "file": "amb/dungeon",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.water": {
      "file": "amb/water",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.interior": {
      "file": "amb/interior",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.lake": {
      "file": "amb/lake",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    },
    "amb.river": {
      "file": "amb/river",
      "start": 0.25,
      "dur": 24,
      "src": [
        "tm"
      ]
    },
    "amb.stream": {
      "file": "amb/stream",
      "start": 0.25,
      "dur": 24,
      "src": [
        "tm"
      ]
    },
    "amb.falls": {
      "file": "amb/falls",
      "start": 0.25,
      "dur": 24,
      "src": [
        "tm"
      ]
    },
    "amb.fire": {
      "file": "amb/fire",
      "start": 0.25,
      "dur": 8.5,
      "src": [
        "tm"
      ]
    },
    "amb.wind": {
      "file": "amb/wind",
      "start": 0.25,
      "dur": 30,
      "src": [
        "tm"
      ]
    }
  }
};
